import { render, staticRenderFns } from "./RegrasExternasComponent.vue?vue&type=template&id=52582b32"
import script from "./RegrasExternasComponent.vue?vue&type=script&lang=js"
export * from "./RegrasExternasComponent.vue?vue&type=script&lang=js"
import style0 from "./RegrasExternasComponent.vue?vue&type=style&index=0&id=52582b32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports